// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1178b3cb","833":"c2b3a84f"}[chunkId] + ".chunk.js";
};